
<template>
   <div>

      <v-toolbar color="deep-orange darken-2" dark>
         <v-toolbar-title>{{ user.fullname }} {{ activeItem ? ' - ' + activeItem.name : '' }}</v-toolbar-title>
      </v-toolbar>

      <div class="flex-container">
            <v-navigation-drawer class="left-element deep-orange lighten-5" mini-variant ini-variant-width="100" v-model="drawer" permanent>
               <v-list>
                  <v-list-tile v-for="item in items" :value="activeItem" :key="item.title" @click="activeItem = item" class="yellow--text"
                        :to="baseRoute + item.path"
                        active-class="red--text">
                     <v-list-tile-action>
                        <v-badge right color="brown">
                           <span slot="badge" v-if="item.path === 'messages' && unreadMessageCount > 0">{{ unreadMessageCount }}</span>
                           <v-icon>{{ item.icon }}</v-icon>
                        </v-badge>
                     </v-list-tile-action>
                  </v-list-tile>
               </v-list>
            </v-navigation-drawer>

            <router-view class="right-element"></router-view>
         
      </div>

   </div>
</template>


<script>

   export default {

      props: {
         userId: Number,
         realm: String,
         items: Array,
         baseRoute: String,
      },

      mounted () {
         // used for selecting user in cousin user list
         this.$emit('userIdChanged', this.userId)
      },

      updated: function() {
         // used for selecting user in cousin user list
         this.$emit('userIdChanged', this.userId)
      },

      data () {
         return {
            drawer: true,
            clipped: false,
            activeItem: null,
         }
      },

      computed: {
         user() {
            return this.$store.state.users[this.userId]
         },
         unreadMessageCount () {
            return this.$store.state.user2unreadMessageCount[this.userId]
         },
      },
   };
</script>

<style scoped>
.flex-container {
   display: flex;
}

.left-element {
   min-width: 80px;
}

.right-element {
   margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// CoachedUserWorkspace.vue?8e7d0306